import React, { useState } from "react";
import {
  TooltipIconBtn,
  TooltipContainer,
  TooltipOuter,
  TooltipText,
} from "./style";
import Icon from "../../../../../../common/Icon";

const Tooltip = ({ text }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  return (
    <>
      <TooltipIconBtn
        onMouseEnter={() => setShowTooltip((prevState) => !prevState)}
        onMouseLeave={() => setShowTooltip((prevState) => !prevState)}
      >
        <Icon type={"info"} size="20px" color="#BEBDC0" />
      </TooltipIconBtn>

      <TooltipContainer>
        {showTooltip && (
          <TooltipOuter>
            <TooltipText>{text}</TooltipText>
          </TooltipOuter>
        )}
      </TooltipContainer>
    </>
  );
};

export default Tooltip;
